import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useSuccessSnackbar } from 'reservations/base/hooks/useSnackbar';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useInvitedGuests } from 'reservations/booking/providers/BookingProvider';
import { useRemoveGuestMutation } from 'reservations/guests/queries/useRemoveGuestMutation';

export const RemoveGuestModal = () => {
  const enqueueSuccessSnackbar = useSuccessSnackbar();
  const guests = useInvitedGuests();
  const restaurantName = useRestaurantName();
  const {
    back,
    modalContext: { visitIdToRemove }
  } = useModal();
  const guestName = guests?.find(({ id }) => id === visitIdToRemove)?.name;
  const subheader = `By taking this action, this guest will be removed from your reservation at ${restaurantName}. If you'd like for them to rejoin the reservation, you'll need to send them a new invitation link.\n\nThis will not change your party size.`;
  const onSuccess = () => {
    enqueueSuccessSnackbar(
      'REMOVE_GUEST_SUCCESS',
      `${guestName} has been removed from the party.`
    );
    back();
  };
  const leaveBookingMutation = useRemoveGuestMutation(
    visitIdToRemove,
    onSuccess
  );

  return (
    <BaseDrawer
      header={`Remove ${guestName ?? 'guest'}`}
      subheader={subheader}
      primaryButton={{
        label: 'REMOVE GUEST',
        onClick: leaveBookingMutation.mutate,
        variant: 'error'
      }}
      secondaryButton={{}}
      dataTestId="remove-guest-modal"
      requireAuth
    />
  );
};
